
import { z } from "zod"; 
import { RiskRegistryItem, OperationalRecommendation, MitigationRequirement, DeployerImpact } from "../RiskRegistry";
import type { AssertSchemaMatchesClass } from "../../../utils/typeUtils";
import { HarmCategories } from "../../risk/Harm";
import { RiskRanks } from "../../risk/Risk";
import { HazardSchema } from "../../risk/schemas/Hazard.schema";

const _OperationalRecommendationZod = z.object({
    description: z.string().default(""),
    label: z.string().default("")
})
// Assert that schema matches the class definition
void (true as AssertSchemaMatchesClass<typeof _OperationalRecommendationZod, OperationalRecommendation>);
export const OperationalRecommendationSchema = _OperationalRecommendationZod.transform((data) => new OperationalRecommendation(data));


const _MitigationRequirementZod = z.object({
    description: z.string().default(""),
    label: z.string().default(""),
    lifeCycleStage: z.string().default(""),
    
    accountableOwner: z.string().default(""),
    conditionsOfAcceptability: z.string().default("")
})  
// Assert that schema matches the class definition
void (true as AssertSchemaMatchesClass<typeof _MitigationRequirementZod, MitigationRequirement>);
export const MitigationRequirementSchema = _MitigationRequirementZod.transform((data) => new MitigationRequirement(data));


const _DeployerImpactZod = z.object({
    description: z.string().default(""),
    label: z.string().default(""),
    impactArea: z.string().default("")
})
// Assert that schema matches the class definition
void (true as AssertSchemaMatchesClass<typeof _DeployerImpactZod, DeployerImpact>);
export const DeployerImpactSchema = _DeployerImpactZod.transform((data) => new DeployerImpact(data));



const _RiskRegistryItemZod = z.object({
    id: z.string().default(""),
    label: z.string().default(""),
    harmCategory: z.enum(HarmCategories).default("financial"),
    riskOwner: z.string().default(""),
    lifeCycleStage: z.string().default(""),
    riskRank: z.enum(RiskRanks).default(RiskRanks[0]),
    riskScenarioDescription: z.string().default(""),
    operationalRecommendations: z.array(OperationalRecommendationSchema).default([]),
    causalHazards: z.array(HazardSchema).default([]),
    deployerImpact: z.array(DeployerImpactSchema).default([]),
    mitigationRequirements: z.array(MitigationRequirementSchema).default([]),
    enablingFactors: z.array(HazardSchema).default([])
})
// Assert that schema matches the class definition
void (true as AssertSchemaMatchesClass<typeof _RiskRegistryItemZod, RiskRegistryItem>);
export const RiskRegistryItemSchema = _RiskRegistryItemZod.transform((data) => new RiskRegistryItem(data));

